export default {
  ON: "on",
  OFF: "off",
  COMPOSING_COMMENT: "composingComment"
}
